export default __webpack_public_path__ + "static/media/STP.efbb7f57.svg";